import React from "react";
import { withStyles } from "@material-ui/core/styles";
import MuiDialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import Zoom from "@material-ui/core/Zoom";
import { ReactComponent as ConfirmAccountManImage } from "../../assets/svg/confirmaccountman.svg";
import { RegistrationLoader } from "../lottie/Loader";
import {validateForm} from "../../services/validateForm";
import { ReactComponent as CrossSvg } from "../../assets/svg/crossicon.svg";

function Transition(props) {
  return (
    <Zoom
      direction={"right"}
      {...props}
      style={{ transformOrigin: "75% 50% 0" }}
    />
  );
}

const Dialog = withStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
    width: "100%",
    maxHeight: "100vh",
    position: "absolute",
    zIndex: 100000,
    top: 0,
    right: 0,
    padding: 0,
    borderRadius: 0,
    background: " rgba(0,0,0,.32)",
    height: window.innerHeight
  },
  closeButton: {
    position: "absolute",
    right: 0,
    top: 0,
    color: theme.palette.grey[500]
  }
}))(props => {
  const { children, classes, onClose, open, TransitionComponent } = props;
  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      TransitionComponent={TransitionComponent}
      classes={{ paper: classes.root }}
    >
      {children}
    </MuiDialog>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    margin: 0,
    padding: 0,
    height: window.innerHeight
    // height:'100%',
    // maxHeight:"100%"
  }
}))(MuiDialogContent);

/**UI component for getting email or contact number of user */
class GetUserDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: { email: "", contact: "" },
      errors: {}
    };
    this.fields = props.fields.map(field => ({
      field: field.toLowerCase(),
      type: `${field.toLowerCase() === "contact" ? "number" : "email"}`,
      placeholder: `${
        field.toLowerCase() === "contact"
          ? "Enter your Contact Number"
          : "Enter your Email"
      }`
    }));
  }
  handleTextChange = event => {
    const {
      target: { name, value }
    } = event;
    const data = { ...this.state.data };
    data[name] = value;
    this.setState({ data });
  };

  onSubmit = () => {
    const errors = validateForm(this.state.data);
    const fields = this.props.fields.map(field => field.toLowerCase());
    let field;
    if (fields.length === 1) {
      if (fields[0] === "email") {
        delete errors["contact"];
        field = "email";
      } else if (fields[0] === "contact") {
        delete errors["email"];
        field = "contact";
      }
    }
    this.setState({ errors });
    const data = fields.length === 1 ? this.state.data[field] : this.state.data;
    if (!Object.keys(errors).length) {
      this.props.onSubmit(data);
    }
  };

  render() {
    const { errors } = this.state;
    const { open, addEmailContactData, tagLine, onClose, showLoader } = this.props;
    return (
      <div id="settings-section">
        <Dialog
          aria-labelledby="Get User Details"
          open={open}
          TransitionComponent={Transition}
          onClose={onClose}
        >
          <DialogContent
            style={{ paddingTop: "0px" }}
            className="settings-section"
          >
            <a
              style={{ cursor: "pointer", marginRight: "20px" }}
              onClick={onClose}
              className="close-btn"
            >
              <CrossSvg />
            </a>
            {showLoader && (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  background: "rgba(0,0,0,.32)",
                  position: "absolute"
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "25%",
                    left: "18%",
                    zIndex: 10000000
                  }}
                >
                  <RegistrationLoader />
                </div>
              </div>
            )}
            <div className="ph-blue content text-center">
              <section className="post-register-confirmation">
                <ConfirmAccountManImage height="40vh" />

                <h3 className="h3 light text-white m-t-35">
                  Confirm Your Details
                </h3>

                <h4 className="h4 light text-white m-t-15">{tagLine}</h4>

                <form
                  style={{ width: "330px", margin: "50px auto 30px" }}
                  className="form"
                >
                  {this.fields.map(({ field, type, placeholder }) => (
                    <div className="form-group m-b-20" key={field}>
                      <input
                        value={this.state.data[field]}
                        onChange={this.handleTextChange}
                        type={type}
                        name={field}
                        className="form-control m-b-10"
                        placeholder={placeholder}
                      />
                      {errors[field] && (
                        <div className="error-text">{errors[field]}</div>
                      )}
                      {addEmailContactData.isError &&
                        addEmailContactData.data &&
                        addEmailContactData.data.Reason &&
                        addEmailContactData.data.Reason}
                    </div>
                  ))}
                </form>
                <button
                  onClick={this.onSubmit}
                  disabled={showLoader}
                  style={{ outline: "none" }}
                  type="submit"
                  className="btn btn-1 lg link"
                >
                  Confirm
                </button>
              </section>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

export default GetUserDetails;
